<template>
  <div>
    <b-modal id="modalEditCaptivePortal" ref="modalEditCaptivePortal" @shown="shown"
      title="Captive portal" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" v-if="editItem.cp_utariff_data_id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.cp_utariff_data_id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.tariff_id" :options="tariffs" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.accounting_period_id" :options="accountingPeriods"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditCaptivePortal')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    tariffs: null,
    groups: null,
    accountingPeriods: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.editItem.is_enabled = Number(this.editItem.is_enabled)
      let response = this.editItem.cp_utariff_data_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_CAPTIVE_PORTAL', this.editItem)
        : this.$store.dispatch('Settings/CREATE_CAPTIVE_PORTAL', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_CAPTIVE_PORTAL')
          this.$refs.modalEditCaptivePortal.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/captivePortal/editModal.vue